<template>
  <div>
    <hr />
    <div class="row">
      <div class="col-12 col-sm-6 col-md-3">
        <fg-input
          type="text"
          :label="`${$t('common_words.code_serial')}: *`"
          v-model="model.code"
          name="common_words.code"
          v-validate="modelValidations.code"
          :error="getError('common_words.code', true)"
          placeholder="FHg56#g67BcaeF5"
        ></fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.name')}: *`"
          v-model="model.name"
          name="common_words.name"
          v-validate="modelValidations.name"
          :error="getError('common_words.name', true)"
          :placeholder="`${$t('devices.sensor_name')}...`"
        ></fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-2">
        <fg-input
          type="text"
          :label="`${$t('labor.unit')}: *`"
          v-model="model.unit"
          name="labor.unit"
          v-validate="modelValidations.unit"
          :error="getError('labor.unit', true)"
          placeholder="°C ..."
          maxlength="10"
        ></fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-3">
        <div class="form-group has-label">
          <label>¿{{ $t('devices.calculated') }}?: *</label>
          <br />
          <el-select
            filterable
            class="select-primary mb-3 shadow-sm required-calculated"
            v-model="model.calculated"
            :placeholder="`${$t('common_words.select2')}...`"
          >
            <el-option
              class="select-primary"
              v-for="item in [
                { id: 0, value: $t('common_words.mayus_no') },
                { id: 1, value: $t('common_words.mayus_yes') },
              ]"
              :key="item.id + item.value"
              :label="item.value"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 col-sm-6 col-md-4">
        <div class="form-group has-label">
          <label for="">¿{{ $t('devices.probe_belongs') }}?: *</label>
          <br />
          <el-select
            filterable
            class="select-primary mb-3 shadow-sm required-firstStep"
            v-model="model.is_probe"
            :placeholder="`${$t('common_words.select2')}...`"
          >
            <el-option
              class="select-primary"
              v-for="item in [
                { id: 0, value: $t('common_words.mayus_no') },
                { id: 1, value: $t('common_words.mayus_yes') },
              ]"
              :key="item.id + item.value"
              :label="item.value"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.description_or_alias')}: *`"
          v-model="model.two_name"
          :placeholder="`${$t('devices.sensor')}...`"
          name="common_words.description_or_alias"
          v-validate="modelValidations.two_name"
          :error="getError('common_words.description_or_alias', true)"
        ></fg-input>
      </div>
      <div class="col-12 col-md-4">
        <div class="form-group has-label">
          <label>{{ $t('common_words.values') }}:</label>
          <br />
          <el-select
            clearable
            filterable
            multiple
            class="select-primary custom-width-select shadow-sm"
            size="large"
            v-model="model.field"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              class="select-primary"
              value="Mínimo"
              :label="$t('common_words.minimum')"
            ></el-option>
            <el-option
              class="select-primary"
              value="Máximo"
              :label="$t('common_words.maximum')"
            ></el-option>
            <el-option
              class="select-primary"
              value="Promedio"
              :label="$t('common_words.percentage')"
            ></el-option>
            <el-option
              class="select-primary"
              value="Suma"
              :label="$t('common_words.addition')"
            ></el-option>
            <el-option
              class="select-primary"
              value="Ultimo"
              :label="$t('common_words.last')"
            ></el-option>
            <el-option
              class="select-primary"
              value="Tiempo"
              :label="$t('common_words.time')"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label>{{ $t('common_words.color') }}:</label>
          <sketch-picker :value="colors" @input="updateValue"></sketch-picker>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MixinColors from 'src/util/mixinColor';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';

export default {
  data() {
    return {
      model: {
        name: null,
        code: null,
        two_name: null,
        unit: null,
        color: null,
        field: [],
        is_probe: 0,
        calculated: 0,
      },
      modelValidations: {
        name: {
          required: true,
        },
        two_name: {
          required: true,
        },
        code: {
          required: true,
        },
        unit: {
          required: true,
          max: 10,
        },
        color: {
          required: true,
        },
      },
    };
  },
  mixins: [MixinPermissions, MixinForm, MixinColors],
  methods: {
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', res, this.model);

        this.$emit('fillSensorForm', 'firstStep');
        return res;
      });
    },
  },

  mounted() {
    let editForm = {};
    this.model.color = this.colors; //.hex
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.code = editForm.code;
      this.model.name = editForm.name;
      this.model.two_name = editForm.two_name;
      this.model.color = editForm.color;
      this.model.field = editForm.field.split(',');
      this.model.is_probe = editForm.is_probe;
      this.model.calculated = editForm.calculated;
      this.model.unit = editForm.unit;
      this.colors = this.model.color;
      this.forceRerender();
    }
  },
};
</script>
<style></style>
